import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, firstValueFrom } from 'rxjs';

const ALLOWED_ROLES = ['cordellidentity.user', 'cordellidentity.admin'];

export const roleGuard: CanActivateFn = async () => {
  const msalService = inject(MsalService);
  const msalBroadcast = inject(MsalBroadcastService);
  const router = inject(Router);

  await firstValueFrom(
    msalBroadcast.inProgress$.pipe(
      filter((status) => status === InteractionStatus.None)
    )
  );

  const account = msalService.instance.getActiveAccount()
    ?? msalService.instance.getAllAccounts()[0];

  if (!account) {
    return router.createUrlTree(['/access-denied']);
  }

  const claims = account.idTokenClaims as Record<string, unknown>;
  //console.log('ID Token Claims:', claims);

  const roles = claims?.['roles'] as string[] | undefined;
  //console.log('Roles:', roles);

  const hasRole = roles?.some((role) => ALLOWED_ROLES.includes(role)) ?? false;
  //console.log('Has required role:', hasRole);

  return hasRole || router.createUrlTree(['/access-denied']);
};
